<template>
    <div class="text-center relative" :class="customClass" v-el-boundary v-click-away="onClickAway" data-cy="container_lang_switcher">
        <div class="flex items-center cursor-pointer p-3" @click="toggle()" data-cy="btn_lang_switcher_toggle">
            <div
                class="flex-grow uppercase font-medium text-dark-1 font-main-medium"
                data-cy="text_lang_switcher_current"
            >{{ localShort }}</div>
            <div class="flex-none ml-1">
                <img src="@/assets/icons/arrow/arrow-down.svg" data-cy="icon_lang_switcher_arrow" />
            </div>
        </div>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-100"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <ul
                v-if="showList"
                ref="ddlList"
                class="fixed origin-top-right right-1 z-10 -mt-2 bg-white shadow-lg max-h-60 rounded-md text-sm overflow-auto focus:outline-none"
                tabindex="-1"
                role="listbox"
                aria-labelledby="listbox-label"
                data-cy="list_lang_switcher_options"
            >
                <template v-for="(item, idx) of items" :key="`ddl-${idx}`">
                    <li
                        class="text-dark-1 cursor-default select-none relative py-2 px-4 hover:bg-gray-100"
                        :class="{ 'bg-gray-200': item.value == localeCode }"
                        role="option"
                        @click="onClickChangeLang(item.value)"
                        :data-cy="`card_lang_switcher_item_${idx}`"
                    >
                        <div class="flex items-center font-medium text-sm">{{ item.text }}</div>
                    </li>
                </template>
            </ul>
        </transition>

        <!-- <div class="flex flex-row font-main-regular text-white text-sm leading-normal">
            <span class="mr-6"
                @click="switchLang(1033)"
                :class="isActive(1033)">
                {{lbl.lang.eng}}
            </span>
            <span
                @click="switchLang(1054)"
                :class="isActive(1054)">
                {{lbl.lang.thai}}
            </span>
        </div>-->
    </div>
</template>
<script>
import PropsHelper from "@/helper/PropsHelper";
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "LangSwitcher",
    mixins: [LocaleMixin],
    props: {
        customClass: {
            type: String
        },
        width: {
            type: [Number, String],
            default: undefined
        },
    },
    inject: ["UserLevels"],
    data: function () {
        return {
            showList: false,
            items: [
                {
                    text: "EN",
                    value: 1033
                },
                {
                    text: "TH",
                    value: 1054
                }
            ]
        }
    },
    computed: {
        widthComputed: function () {
            if (this.width != undefined) {
                return PropsHelper.getBoxUnit(this.width)
            } else {
                if (this.parentOffset.width != undefined) {
                    return PropsHelper.getBoxUnit(this.parentOffset.width)
                }
            }
            // console.log(this.width, PropsHelper.getBoxUnit(this.width))
            return null // ignore this property in style object
        },
    },
    methods: {
        isActive: function (localCode) {
            if (this.localeCode == localCode) {
                // this.setTracking(localCode);
                return 'underline';
            }
        },
        toggle: function () {
            this.showList = !this.showList
        },
        hide: function () {
            this.showList = false
        },
        show: function () {
            this.showList = true
        },
        onClickAway: function () {
            this.hide();
        },
        onClickChangeLang: function (val) {
            // log
            /**@type {import("@/helper/TrackingHelper").TrackingService} */
            const trackingService = this.tracking

            if (this.UserLevels.isPlatinum) {
                trackingService.event("campaignlist_language", "click_language_campaignlist_platinum", "", val)
            }
            else {
                trackingService.event("campaignlist_language", "click_language_campaignlist_gold", "", val)
            }

            this.$nextTick(() => {
                this.switchLang(val)
            })
        }
        // setTracking: function(localCode){
        //     let trackCategory = 'change_language';
        //     let trackAction = localCode == 1033 ? 'click_language_eng' : 'click_language_th';
        //     this.tracking.event(trackCategory, trackAction, null, null);
        // }
    }
}
</script>
